import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/database';
import 'firebase/compat/storage';

export const updateUser = async (userData) => {
  const currentUser = await firebase.auth().currentUser;

  return firebase
    .database()
    .ref(`users/${currentUser.uid}`)
    .update({ ...userData, uid: currentUser.uid });
};

export const getAppVersionRef = () => firebase.database().ref(`/app_version`);

export const getReleaseRef = () => firebase.database().ref(`/release/`);
